// src/components/StatsBar/StatsBar.jsx
import React from "react"
import styled from "styled-components"
import SkeletonLoader from "./SkeletonLoader"
import DropdownLogout from "./DropdownLogout"

// ======== styled-components ========
const StatsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  font-size: 0.95rem;
  color: #222;
  margin-bottom: 15px;
  padding: 15px;
`

const FlagWrapper = styled.div`
  width: 32px;
  height: auto;
  border-radius: 2px;
  flex-shrink: 0;
  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`

const StatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 500;

  span {
    align-items: center;
    display: flex;
  }
`

const IconWrapper = styled.span`
  font-size: 1.1rem;
  color: #555;
  align-items: center;
`

const Value = styled.span`
  font-weight: bold;
  align-items: center;
`

const Sub = styled.span`
  font-size: 0.8rem;
  color: #777;
`

// ======== Función bandera ========
function getFlagSvg(country = "") {
    const c = (country || "")?.toLowerCase()
    switch (c) {
        case "chile":
            return (
                <svg width="21" height="15" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0)">
                        <rect width="21" height="15" rx="3" fill="white" />
                        <path d="M19 0H2C0.9 0 0 0.9 0 2V13C0 14.1 0.9 15 2 15H19C20.1 15 21 14.1 21 13V2C21 0.9 20.1 0 19 0Z" fill="white" />
                        <path d="M0 8H21V15H0V8Z" fill="#F93939" />
                        <path d="M0 0H9V8H0V0Z" fill="#1A47B8" />
                        <path d="M4.5 5.227L3.03 6L3.31 4.364L2.122 3.204L3.765 2.966L4.5 1.476L5.235 2.966L6.878 3.206L5.688 4.364L5.97 6" fill="white" />
                    </g>
                    <defs>
                        <clipPath id="clip0">
                            <rect width="21" height="15" rx="3" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            )
        case "colombia":
            return (
                <svg width="21" height="15" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip1)">
                        <path d="M19 0H2C0.9 0 0 0.9 0 2V13C0 14.1 0.9 15 2 15H19C20.1 15 21 14.1 21 13V2C21 0.9 20.1 0 19 0Z" fill="#1A47B8" />
                        <path d="M0 11H21V15H0V11Z" fill="#F93939" />
                        <path d="M0 0H21V7H0V0Z" fill="#FFDA2C" />
                    </g>
                    <defs>
                        <clipPath id="clip1">
                            <rect width="21" height="15" rx="3" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            )
        case "argentina":
            return (
                <svg width="21" height="15" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip2)">
                        <path d="M19 0H2C0.9 0 0 0.9 0 2V13C0 14.1 0.9 15 2 15H19C20.1 15 21 14.1 21 13V2C21 0.9 20.1 0 19 0Z" fill="white" />
                        <path d="M0 10H21V15H0V10ZM0 0H21V5H0V0Z" fill="#3ECBF8" />
                        <path d="M10.5 9C11.33 9 12 8.33 12 7.5C12 6.67 11.33 6 10.5 6C9.67 6 9 6.67 9 7.5C9 8.33 9.67 9 10.5 9Z" fill="#FFDA2C" />
                    </g>
                    <defs>
                        <clipPath id="clip2">
                            <rect width="21" height="15" rx="3" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            )
        case "peru":
            return (
                <svg width="21" height="15" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip3)">
                        <path d="M19 0H2C0.9 0 0 0.9 0 2V13C0 14.1 0.9 15 2 15H19C20.1 15 21 14.1 21 13V2C21 0.9 20.1 0 19 0Z" fill="white" />
                        <path d="M0 0H7V15H0V0ZM14 0H21V15H14V0Z" fill="#F93939" />
                    </g>
                    <defs>
                        <clipPath id="clip3">
                            <rect width="21" height="15" rx="3" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            )
        case "brasil":
        case "brazil":
            return (
                <svg width="21" height="15" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                    <rect width="21" height="15" rx="3" fill="#249F58" />
                    <path d="M10.5 2L18 7.5L10.5 13L3 7.5" fill="#FFDA2C" />
                    <path d="M10.5 11C12.43 11 14 9.43 14 7.5C14 5.57 12.43 4 10.5 4C8.57 4 7 5.57 7 7.5C7 9.43 8.57 11 10.5 11Z" fill="#1A47B8" />
                </svg>
            )
        default:
            return null
    }
}

// ======== Componente principal ========
export default function StatsBar({ country, stats = [], loaderCountry }) {
    return (
        <StatsContainer>
            {country && <SkeletonLoader active={loaderCountry}><FlagWrapper>{getFlagSvg(country)}</FlagWrapper></SkeletonLoader>}

            {stats.map((item, index) => {
                // Asegurar que value y sub sean valores primitivos válidos
                const displayValue = (item.value !== null && item.value !== undefined && typeof item.value !== 'object') 
                    ? item.value 
                    : (typeof item.value === 'number' ? item.value : 0);
                const displaySub = (item.sub !== null && item.sub !== undefined && typeof item.sub !== 'object')
                    ? item.sub
                    : null;
                
                return (
                    <SkeletonLoader key={index} active={item.loader}>
                        <StatItem>
                            {item.icon && <IconWrapper>{item.icon}</IconWrapper>}
                            <Value>{displayValue}</Value>
                            {displaySub && <Sub>/{displaySub}</Sub>}
                        </StatItem>
                    </SkeletonLoader>
                );
            })}
            <StatItem>
                <DropdownLogout color="black"/>
            </StatItem>
        </StatsContainer>
    )
}